import React,{useState} from 'react';
import styled from 'styled-components';
import {Link } from "react-router-dom"; 
import Bottom_Modal_var2 from 'components/modal/Bottom_Modal_var2'

import LottieLoader from 'components/containers/common/LottieLoader';
import loadingImg from 'images/lottiefile/yellow_loading_animation.json';
import friend_check from 'images/friend_check.png'
import plusicon from 'images/plusicon.png'
import appInfoContainer from 'auth/appInfoContainer';


// 하단 모달 창 리스트 
let modallist = [
    {text:"친구 취소",color:"#de0000",} ,
  ]

export default function FriendList(props) {
    return <div> {
                    props.friendlist.map((value) => {
                        return <FriendStatus 
                            key={`friend-list-item-no-${value['no']}`}
                            setButtonState={props.setButtonState} 
                            setModalShow={props.setModalShow} 
                            display={props.display} 
                            name={value.to_nickname}
                            deleteSubmit={props.deleteSubmit}
                            setCurrentPostIndex={props.setCurrentPostIndex}
                            no={value.to_user_no}
                            value={value}
                        />
                    })
                }

            {(!props.isEnd)&&(
                <LoadingWrapper>
                    <LottieLoader 
                    lottieOptions={{
                    loop: true,
                    autoplay: true,
                    renderer: 'svg',
                    animationData: loadingImg
                    }} 
                    style={{position: 'absolute', top: '0', bottom: '0', left: '0', right: '0'}}/> 
                </LoadingWrapper>
            )}
                
            </div>
    // <FriendStatus name={props.nickname}  display={props.display}></FriendStatus>;
}

function AddFriendButton({click}){
    return (
        <Button onClick={click}>
            <PlusIcon><img src={plusicon} alt={'add friend button'}/></PlusIcon>
            <Txt>친구</Txt>
        </Button>
    )
}


function RemoveFriendButton({click}){
    return (
        <Button2 onClick={click}>
            <Txt2>친구</Txt2>
            <Check><img src={friend_check} alt={'friend confirm button'}/> </Check>
        </Button2>
    )
}

function FriendStatus({openModal,display,name,deleteSubmit,setCurrentPostIndex,no,value}) {
   const [buttonState,setButtonState] = useState(false);
   const [modalShow,setModalShow] = useState(false);

   const init = () => {
     modallist[0].clickEvent = () =>{
         setModalShow(false);
         deleteSubmit();
         alert("삭제")
        // setButtonState(false);
    }
   }
   init();
    function onClick(){
        setButtonState(true);
    }
    function ClickModal(){
        setModalShow(true);
        setCurrentPostIndex(no)
    }

    return(
        <>
            <Div>
                <Ul>
                    <Li><Link component={A} to={`/task/friend/${no}/list`}><Images src={appInfoContainer.imagePath +"/user_profile_img/"+value.to_user_profile_img}/></Link> <Name>{name}</Name></Li>
                    <Li>
                        <b>
                            {/* {
                            buttonState == false? 
                            <AddFriendButton click={onClick}/>
                            : */}
                            <RemoveFriendButton click={ClickModal}/>
                            {/* } */}
                    
                        </b>
                        <DotBt onClick={openModal} display={display}><Dot></Dot></DotBt>
                    </Li>
                </Ul>
            </Div>
            <Bottom_Modal_var2
            data={modallist}
            cancle={true}
            show={modalShow}    //모달 보여지는 여부
            setModalShow={setModalShow}
        />
    </>
    )
}

// function FL() {
//     return <div style={styles.test}/>
// }


// let styles ={
//     test:{
//         backgroundColor:"grey",
//         width:200,
//         height:200,
//         margin:10,
//         paddingTop:10,
//     }
// }


const Div = styled.div`
    padding: 0 calc(100vw*(22/375)); 0 calc(100vw*(17/375));
    margin-bottom : calc(100vw*(22/375));
`
const Ul = styled.ul`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const Li = styled.li`
    display:flex;
    align-items: center;
`
const Images = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const A = styled.a`
    display:block;
    width: calc(100vw*(56/375));
    height: calc(100vw*(56/375));
    border-radius: 100%;
    overflow: hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`
const Name = styled.span`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    margin-left: calc(100vw*(11/375));
`
const Button = styled.button`
    width: calc(100vw*(67/375));
    height: calc(100vw*(27/375));
    border-radius: calc(100vw*(5/375));
    border: solid 1px #e6e6e6;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
`
const Button2 = styled(Button)`
    background-color: #4e4e4e;
`
const PlusIcon = styled.span`
    position: relative;
    display:block;
    width: calc(100vw*(10/375));
    height: calc(100vw*(10/375));
    margin-right: calc(100vw*(3/375));
`
const Txt = styled.span`
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    color: #4e4e4e;
`
const Txt2 = styled(Txt)`
    color: #fff;
`
const Dot = styled.span`
    position:relative;
    display:block;
    width: calc(100vw*(4/375));
    height: calc(100vw*(4/375));
    background-color: #292724;
    border-radius:50%;
    margin-left: calc(100vw*(8/375));
    opacity: 0.4;

    &::before {
        content:'';
        position: absolute;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background-color: #292724;
        border-radius:50%;
        top:calc(100vw*(6/375));
        left:0;
    }
    &::after {
        content:'';
        position: absolute;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background-color: #292724;
        border-radius:50%;
        bottom:calc(100vw*(-12/375));
        left:0;
    }
`
const DotBt = styled.a`
    display: ${props=>props.display};
    width: 100%;
    height: calc(100vw*(17/375));
`

const Check = styled.p`
    width: calc(100vw*(10.2/375));
    height: calc(100vw*(7.9/375));
    margin-left: calc(100vw*(3/375));
`

export const LoadingWrapper = styled.div`
    position :relative;
    height: calc(100vw*(35/375));
    width : 100%;
    margin-top : calc(100vw*(10/375));
`